'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = injectPreparedData;

var _fromGraphQL = require('react-relay/lib/fromGraphQL');

var _fromGraphQL2 = _interopRequireDefault(_fromGraphQL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function injectPreparedData(environment, data) {
  var storeData = environment.getStoreData();

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref2 = _step.value;
      var concreteQuery = _ref2.query,
          response = _ref2.response;

      var query = _fromGraphQL2.default.Query(concreteQuery);
      storeData.handleQueryPayload(query, response);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/dibs-isomorphic-relay/lib/injectPreparedData.js
// module id = 2810
// module chunks = 63